import { useLocation, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ShieldOff } from "lucide-react";
import BotSweepLogo from "@/components/landing/BotSweepLogo";
import NoiseOverlay from "@/components/landing/NoiseOverlay";
import { usePageSEO } from "@/hooks/usePageSEO";

const NotFound = () => {
  const location = useLocation();

  usePageSEO({ title: "404 — BotSweep", path: location.pathname, noindex: true });

  return (
    <div className="min-h-screen bg-background relative overflow-hidden flex items-center justify-center">
      <NoiseOverlay />
      {/* Background grid */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `linear-gradient(hsl(var(--primary) / 0.3) 1px, transparent 1px), linear-gradient(90deg, hsl(var(--primary) / 0.3) 1px, transparent 1px)`,
          backgroundSize: "60px 60px",
        }}
      />
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-destructive/5 blur-[120px]" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 text-center px-6"
      >
        <div className="flex items-center justify-center gap-3 mb-8">
          <BotSweepLogo size={32} />
          <span className="font-display text-2xl font-bold tracking-tight text-foreground">
            BotSweep<span className="text-primary">.</span>
          </span>
        </div>

        <div className="flex items-center justify-center gap-3 mb-4">
          <ShieldOff className="w-8 h-8 text-destructive" />
          <h1 className="font-data text-7xl font-bold text-foreground">404</h1>
        </div>

        <p className="text-sm font-mono text-muted-foreground mb-2">
          Route not found: <span className="text-destructive font-semibold">{location.pathname}</span>
        </p>
        <p className="text-xs font-mono text-muted-foreground/60 mb-8">
          This endpoint doesn't exist in the BotSweep network.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary text-primary-foreground text-sm font-mono font-semibold hover:bg-primary/90 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Return to Base
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
